import { history } from '../redux/store';

export function irEleccion(val) {
  if (val.tipo)
    history.push({ pathname: '/static/eleccion-hostigamiento', state: val });
  else
    history.push({ pathname: '/static/eleccion', state: val });
}